import type { CheckDuplicateClientsPayload } from '@/types/clientsApiTypes';

interface BuildCheckDuplicateClientsPayloadParams {
  first_name: string;
  last_name: string;
  exclude_client_id?: number;
  email: string;
}

export function buildCheckDuplicateClientsPayload({
  first_name,
  last_name,
  exclude_client_id,
  email,
}: BuildCheckDuplicateClientsPayloadParams): CheckDuplicateClientsPayload {
  return {
    first_name: first_name.trim(),
    last_name: last_name.trim(),
    email: email.trim(),
    ...(exclude_client_id !== undefined && { exclude_client_id }),
  };
}
